module.exports = __webpack_public_path__ + "img/download.84255ef3.svg";